const LoyaltyProgramLogo = () => false;

export default LoyaltyProgramLogo;
